import React from 'react'
import { Box, Typography } from '@mui/material';
import { Footer, Hero, Navbar } from '../components';
import { ContactInfo, Portfolio } from '../containers';

//assets
import webtexts from '../assets/webtexts.json';
import { project1 } from '../assets';

import {celeste_5} from '../assets/images/projects/celeste'
import {hive_1} from '../assets/images/projects/hive'
import {jackson_3} from '../assets/images/projects/jackson'
import {twc_2} from '../assets/images/projects/the-new-chapter'
import {vine_10} from '../assets/images/projects/vine'
import {waterfront_10} from '../assets/images/projects/waterfront'
import {madrona_15} from '../assets/images/projects/madrona'

const Projects = () => {
  
  const projects = [
    {name: 'Celeste Residence', image: celeste_5, path: 'celeste-residence', text:webtexts.projects.find(item => item.id === 'celeste')?.intro, type: 'Residential Building'},
        {name: 'Hive II', image: hive_1, path: 'hive', text:webtexts.projects.find(item => item.id === 'hive')?.intro, type: 'Communal Space'},
        {name: "Jackson House", image: jackson_3, path: 'jackson-house', text:webtexts.projects.find(item => item.id === 'jackson')?.intro, type: 'Residential Building'},
        {name: 'The New Chapter', image: twc_2, path: 'the-new-chapter', text:webtexts.projects.find(item => item.id === 'tnc')?.intro, type: 'Residential Building'},
        {name: 'Vine', image: vine_10, path: 'vine', text:webtexts.projects.find(item => item.id === 'vine')?.intro, type: 'Residential Building'},
        {name: 'Waterfront Eye Wear', image: waterfront_10, path: 'waterfront-eye-wear', text:webtexts.projects.find(item => item.id === 'waterfront')?.intro, type: 'Commercial Space'},
        {name: 'Madrona', image: madrona_15, path: 'madrona', text:webtexts.projects.find(item => item.id === 'madrona')?.intro, type: 'Exclusive Property'}
  ]

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100vh',
      }}
    >
      <Hero />
        <Box
          sx={{
            // paddingY:'2rem'
          }}
        >
          <Portfolio 
          />
        </Box>
        {/* <ContactInfo /> */}

        <Footer />
      
    </Box>
  )
}

export default Projects